<template>
    <div v-if="!isSubscriber" class="right-padding align-top no-vertical-spacing border-box small-box-bottom-padding" style='margin-bottom: 1em'>
        <div class="inline-auto-width">
            Subscribe to see full drafts and features when signed in!&nbsp;&nbsp;
        </div>
        <div class="inline-auto-width" style="white-space: nowrap">
            <b-button variant='primary' to="/subscription">Learn More &raquo;</b-button>&nbsp;&nbsp;
            <login-control v-if="!isAuthenticated" prompt='Sign In' :show-as-link='false'/>
        </div>
    </div>
</template>

<script>
import loginControl from './LoginControl.vue'

export default {
    computed: {
        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },

        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        }
    },
    components: {
        loginControl: loginControl
    }
}
</script>

<style scoped>
.small-box-bottom-padding {
    padding-bottom: 6px
}
</style>



// WEBPACK FOOTER //
// src/components/SubscriberLoginPrompt.vue